export default __webpack_public_path__ + "static/media/isthisok.518ecccc.jpg";